import type { MoTravelDay, MoTravelStop } from '../types/moTravel.types';

const STOP_KEY_SEPARATOR = '#';
const START_KEY_SUFFIX = 'start';

export const getStopKey = (day: MoTravelDay, stop: MoTravelStop): string =>
  `${day.date}${STOP_KEY_SEPARATOR}${stop.seq}`;

export const getStartKey = (day: MoTravelDay): string =>
  `${day.date}${STOP_KEY_SEPARATOR}${START_KEY_SUFFIX}`;

export const isKeyOnDay = (key: string | null, date: string): boolean =>
  key?.startsWith(`${date}${STOP_KEY_SEPARATOR}`) ?? false;
